// extracted by mini-css-extract-plugin
export var buttonsWrapper = "SliderControl-module--buttonsWrapper--6009e";
export var text = "SliderControl-module--text--223f6";
export var white = "SliderControl-module--white--ae497";
export var nextButton = "SliderControl-module--nextButton--1b1ef";